export default "__VITE_ASSET__B8Oa$LSD__"